import Rest from './BaseRest'
import DjangoRest from './DjanoBaseRest'

const resource = 'accounts'
const postfix = 'subscriptions'

export default {
  AccountSubscriptions (accountId) {
    return Rest.get(`${resource}/${accountId}/${postfix}`)
  },
  GetMemberSubscription (accountId, memberId) {
    return Rest.get(`${resource}/${accountId}/${postfix}/${memberId}`)
  },
  StoreSubscription (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}`, payload)
  },
  ReactivateMembers (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/reactivate-members`, payload)
  },
  ReactivateMembersV2 (accountId, payload) {
    return DjangoRest.post(`${resource}/${accountId}/${postfix}/reactivate_members/`, payload)
  },
  AddTab (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/add-tab`, payload)
  },
  UpdateMemberSubscription (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/member/update`, payload)
  },
  RemoveAccountPlans (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/remove-plans`, payload)
  },
  CancelNow (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/cancel-now`, payload)
  },
  PreviewUpcomingSubscription (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/preview`, payload)
  },
  AddPlan (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/add-plan`, payload)
  },
  RemovePlan (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/remove-plan`, payload)
  },
  ChangeBillingCycle (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/change-billing-cycle`, payload)
  },
  ChangeInterval (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/change-interval`, payload)
  },
  SubscriptionByCheck (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/by-check`, payload)
  },
  ChangeBillingDate (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/change-billing-date`, payload)
  },
  ReactivateAccount (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/reactivate-account`, payload)
  },
  ChangeIntervalPreview (accountId, payload) {
    return Rest.post(`${resource}/${accountId}/${postfix}/change-interval-preview`, payload)
  },
  GetMemberSubscriptionV2 (accountId, memberId) {
    return DjangoRest.get(`${resource}/${accountId}/${postfix}/${memberId}`)
  },
  StoreSubscriptionV2 (accountId, payload) {
    return DjangoRest.post(`${resource}/${accountId}/${postfix}/`, payload)
  },
  AccountSubscriptionsV2 (accountId) {
    return DjangoRest.get(`${resource}/${accountId}/${postfix}`)
  },
  UpdateMemberSubscriptionV2 (accountId, payload) {
    return DjangoRest.post(`${resource}/${accountId}/${postfix}/member/update/`, payload)
  },
  DeactivateMember (payload) {
    return DjangoRest.post(`${postfix}/member/deactivate/`, payload)
  },
  UpdateFrequency (subscription_id, payload) {
    return DjangoRest.post(`${postfix}/update_frequency/${subscription_id}/`, payload)
  },
}
